export default "__VITE_ASSET__C1n_R2OH__"